import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=f029bf24&scoped=true&"
import script from "./Undo.vue?vue&type=script&lang=js&"
export * from "./Undo.vue?vue&type=script&lang=js&"
import style0 from "./Undo.vue?vue&type=style&index=0&id=f029bf24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f029bf24",
  null
  
)

component.options.__file = "Undo.vue"
export default component.exports